export default __webpack_public_path__ + "static/media/moodTwo.5aa88942.png";